import{useEffect as o}from"react";import l from"smoothscroll-polyfill";var r=function(){o((function(){l.polyfill()}),[])};export{r as default};
